import request from '../../request';
import { constructUrlObject } from '../../../utils/shared/urlUtils';
import { SHARED_API_URL, PARAM } from '../../../constants/shared/ApiConstants';

const {
    CLASSE,
    SCHOOL,
    PERIOD,
    ASSESSMENT,
    DISTRICT,
    ETERNAL_STUDENT_SID,
    MEASURE,
    RESULT_PROBE,
    GRADE_ID,
    RESULT_GROUP,
    YEAR,
    STUDENT_IDS,
    APPLICATION_SID,
} = PARAM;

class SkylightClient {
    static getR3DResults = (baseUrl, applicationSid, studentIds, district, school, classe) => {
        const { BASE_URLS } = SHARED_API_URL(baseUrl);
        const urlWithQueryParams = constructUrlObject(BASE_URLS.RESULTS_URL, {
            [STUDENT_IDS]: studentIds ? studentIds.join() : '',
            district,
            school,
            classe,
            [APPLICATION_SID]: applicationSid,
        });
        return request.get(urlWithQueryParams);
    };

    static getR3DInterps = (baseUrl, district, school, classe, applicationSid) => {
        const { BASE_URLS } = SHARED_API_URL(baseUrl);
        const urlWithQueryParams = constructUrlObject(BASE_URLS.R3D_INTERPS_URL, {
            district,
            school,
            classe,
            [PARAM.APPLICATION_SID]: applicationSid,
        });
        return request.get(urlWithQueryParams);
    };

    static getProbeDetails = ({
        baseUrl,
        classe,
        school,
        district,
        assessment,
        period,
        year,
        studentSid,
        measure,
        resultId,
        gradeId,
        resultGroup,
    }) => {
        const { BASE_URLS } = SHARED_API_URL(baseUrl);
        const urlWithQueryParams = constructUrlObject(BASE_URLS.PROBE_DETAILS_URL, {
            [CLASSE]: classe,
            [SCHOOL]: school,
            [DISTRICT]: district,
            [ASSESSMENT]: assessment,
            [PERIOD]: period,
            [YEAR]: year,
            [ETERNAL_STUDENT_SID]: studentSid,
            [MEASURE]: measure,
            [RESULT_PROBE]: resultId,
            [GRADE_ID]: gradeId,
            [RESULT_GROUP]: resultGroup,
        });
        return request.get(urlWithQueryParams);
    };
}

export default SkylightClient;
